<!-- Container-fluid starts -->
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="list-product p-2">
        <lib-crud
          [newLabel]="'Add Pharmacy'"
          [items]="PharmacyList"
          (actionHandler)="handleEvent($event)"
          (deleteActionHandler)="deleteRecord($event)"
          [closePopup]="closeFormEvent"
          [openEditPopup]="editRecord"
          [popupWidthPercent]="'80'"
          [popupTitle]="'Pharmacy'"
          [openDeletePopup]="openDeletePopup"
        >
          <!-- Pharmacy Form -->
          <form class="row" formsElement #PharmacyForm="ngForm">
            <div
              class="row"
              style="height: 100%; overflow: hidden; justify-content: space-between;"
            >
              <!-- LEFT PANEL : Queue -->
              <div class="col-md-3  T-pQ border-end p-0 d-flex flex-column">
                <div class="flex-grow-1 overflow-auto p-2">
                  <div class="p-2 border-bottom">
                    <h6 class="mb-1 fw-bold">Today's Queue</h6>
                  </div>

                  <p-scrollPanel [style]="{ width: '100%', height: '370px' }">
                    <div class="list-group list-group-flush p-0 m-0">
                      <button
                        type="button"
                        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-yellow"
                        (click)="autoFillForm('Amit Virkar')"
                      >
                        Amit Virkar <span class="text-muted">12:30 PM</span>
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-green"
                        (click)="autoFillForm('Rohan Shinde')"
                      >
                        Rohan Shinde <span class="text-muted">01:00 PM</span>
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-yellow"
                        (click)="autoFillForm('Priya Sharma')"
                      >
                        Priya Sharma <span class="text-muted">01:30 PM</span>
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-yellow"
                        (click)="autoFillForm('Arjun Desai')"
                      >
                        Arjun Desai <span class="text-muted">02:00 PM</span>
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-blue"
                        (click)="autoFillForm('Neha Kulkarni')"
                      >
                        Neha Kulkarni <span class="text-muted">02:30 PM</span>
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-purple"
                        (click)="autoFillForm('Sagar Patil')"
                      >
                        Sagar Patil <span class="text-muted">03:00 PM</span>
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-yellow"
                        (click)="autoFillForm('Kiran Joshi')"
                      >
                        Kiran Joshi <span class="text-muted">03:30 PM</span>
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-blue"
                        (click)="autoFillForm('Meera Deshmukh')"
                      >
                        Meera Deshmukh
                        <span class="text-muted">04:00 PM</span>
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-yellow"
                        (click)="autoFillForm('Rahul Chavan')"
                      >
                        Rahul Chavan <span class="text-muted">04:30 PM</span>
                      </button>
                      <button
                        type="button"
                        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center bg-light-green"
                        (click)="autoFillForm('Anjali Nair')"
                      >
                        Anjali Nair <span class="text-muted">05:00 PM</span>
                      </button>
                    </div>
                  </p-scrollPanel>
                </div>
              </div>

              <!-- RIGHT PANEL : Form -->
              <div class="col-md-8 border-end p-3 d-flex flex-column T-pharmacyArea">
                <!-- Patient Name (Read Only) -->
                <div class="mb-3 col-md-6 T-pharmacyName">
                  <label for="tname" class="form-label">Patient Name</label>
                  <input
                    type="text"
                    class="form-control"
                    id="tname"
                    name="tname"
                    [(ngModel)]="Pharmacy.name"
                    [readonly]="true"
                  />
                </div>

                <!-- Medicines (Read Only) -->
                <div class="mb-3 col-md-8 T-pharmacyMedicines">
                  <label for="medicines" class="form-label">Medicines</label>
                  <textarea
                    class="form-control"
                    id="medicines"
                    name="medicines"
                    [(ngModel)]="Pharmacy.medicines"
                    rows="3"
                    [readonly]="true"
                  ></textarea>
                </div>

                <!-- Pickup On Date -->
                <div class="mb-3 col-md-4 T-PPickupDate">
                  <label for="pickup_date">Pickup On Date</label>
                  <input
                    type="date"
                    id="pickup_date"
                    name="pickup_date"
                    class="form-control"
                    [(ngModel)]="Pharmacy.visit_date"
                  />
                </div>

                <!-- Pickup On Time -->
                <div class="mb-3 col-md-4 T-PPickupDate">
                  <label for="pickup_time">Pickup On Time</label>
                  <input
                    type="time"
                    id="pickup_time"
                    name="pickup_time"
                    class="form-control"
                    [(ngModel)]="Pharmacy.visit_time"
                  />
                </div>
              </div>
            </div>

            <!-- Footer Save Button -->
            <div class="row" footerButtons>
              <div class="col-md-12 text-end">
                <button
                  type="button"
                  class="btn btn-outline-primary me-2"
                  [disabled]="PharmacyForm.invalid"
                  (click)="processPharmacy()"
                >
                  <i class="pi pi-check"></i>
                  {{ Pharmacy.id ? "Update" : "Save" }}
                </button>
              </div>
            </div>
          </form>
        </lib-crud>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
